/* eslint-disable camelcase */
import { JSErrors } from "@newrelic/browser-agent";
import { AgentOptions } from "@newrelic/browser-agent/src/loaders/agent.js";

export type EnvEnum = "DEV" | "STAGE" | "PROD";

const env = process.env.REACT_APP_ENV as EnvEnum | undefined;

const appID: Record<EnvEnum, string> = {
  DEV: "538777344",
  STAGE: "538777332",
  PROD: "538777325",
};

const currentAPPId = appID[env];

const init = {
  distributed_tracing: { enabled: true },
  privacy: { cookies_enabled: true },
  ajax: { deny_list: ["bam.eu01.nr-data.net"] },
};

const info = {
  beacon: "bam.eu01.nr-data.net",
  errorBeacon: "bam.eu01.nr-data.net",
  licenseKey: "NRJS-10d5c72c1a14d608270",
  applicationID: currentAPPId,
  sa: 1,
};

const loader_config = {
  accountID: "2550020",
  trustKey: "2550020",
  agentID: currentAPPId,
  licenseKey: "NRJS-10d5c72c1a14d608270",
  applicationID: currentAPPId,
};

const config: AgentOptions = {
  init,
  info,
  loader_config,
};

const getNewRelicConfig = (): AgentOptions => {
  if (!env) {
    throw new Error("Missing env information.");
  }

  return config;
};

export default getNewRelicConfig();
